import React from 'react';
import { Hero } from '../components/Hero';
import { ServicesOverview } from '../components/ServicesOverview';
import { ReviewsSection } from '../components/ReviewsSection';
import { ContactSection } from '../components/ContactSection';
export function Home() {
  return <div className="w-full min-h-screen bg-white" data-id="element-394">
      <main data-id="element-395">
        <Hero data-id="element-396" />
        <ServicesOverview data-id="element-397" />
        <ReviewsSection data-id="element-398" />
      </main>
      <ContactSection data-id="element-399" />
    </div>;
}